import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import InputFile from "../InputFile"

const FinancingContractInput = ({ updateSendStatus }) => {
    const { control } = useFormContext()

    const handleFileChange = (file, documentId) => {
        if (file) {
            updateSendStatus(documentId, true);
        }
    };

    return (
        <Controller
            name="FinancingContract"
            control={control}
            render={({ field }) => (
                <InputFile
                    id="FinancingContract"
                    title="Contrato de financiamento"
                    name="FinancingContract"
                    details="Tipo de Arquivo JPG, PNG ou PDF"
                    file={field.value}
                    setFile={(file) => {
                        field.onChange(file);
                        handleFileChange(file, 1);
                    }
                    }
                    maxSize={15}
                    {...field}
                />
            )}
        />
    )
}

export default FinancingContractInput